import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function TermsAndConditions() {
  return (
    <div className="">
      <Header />
      <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px]">
        <section className="bg-gradient-to-br from-[#115B9D] to-[#116DAE]">
          <div className="max-w-[1200px] mx-auto px-5 py-10 text-white text-center">
            <h1 className="text-[28px] sm:text-[36px] font-bold leading-tight">Terms and Conditions</h1>
            <p className="mt-2 text-blue-100 text-sm sm:text-base max-w-2xl mx-auto">
              Please read these terms carefully before using our services.
            </p>
          </div>
        </section>

        <section className="max-w-[1200px] mx-auto px-5 py-10">
          <div className="space-y-10 text-gray-600">
            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">
                By accessing and using this website, you agree to be bound by these Terms and Conditions
                and all applicable laws and regulations. If you do not agree with any of these terms,
                you are prohibited from using or accessing this site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">2. Use License</h2>
              <p className="leading-relaxed">
                Permission is granted to temporarily download one copy of the materials on Charles S. Smith & Associates'
                website for personal, non-commercial transitory viewing only. This is the grant of a license,
                not a transfer of title.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">3. Disclaimer</h2>
              <p className="leading-relaxed">
                The materials on our website are provided on an 'as is' basis. Charles S. Smith & Associates makes no
                warranties, expressed or implied, and hereby disclaims and negates all other warranties including,
                without limitation, implied warranties or conditions of merchantability, fitness for a particular
                purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">4. Limitations</h2>
              <p className="leading-relaxed">
                In no event shall Charles S. Smith & Associates or its suppliers be liable for any damages (including,
                without limitation, damages for loss of data or profit, or due to business interruption) arising
                out of the use or inability to use the materials on our website.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">5. Revisions and Errata</h2>
              <p className="leading-relaxed">
                The materials appearing on our website could include technical, typographical, or photographic errors.
                We do not warrant that any of the materials on its website are accurate, complete, or current.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">6. Governing Law</h2>
              <p className="leading-relaxed">
                Any claim relating to Charles S. Smith & Associates' website shall be governed by the laws
                of the jurisdiction in which we operate without regard to its conflict of law provisions.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">7. Order Acceptance</h2>
              <p className="leading-relaxed">
                Receipt of an order number or an order confirmation email does not constitute the acceptance of an order
                or a confirmation of an offer to sell. We reserve the right, without prior notification, to limit the
                order quantity on any item and/or to refuse service to any customer.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">Contact Us</h2>
              <p className="leading-relaxed">
                If you have any questions about these Terms and Conditions, please contact us at info@charlessmithassociates.com.
              </p>
            </div>
          </div>
        </section>
      </div>
      {methodModel.TokenChecker() && <Footer />}
    </div>
  );
}
